/* Rose & Co. — storefront behaviour on Shopify: AJAX add-to-basket, toast,
   live basket count, cart line updates. Mirrors the original static site's UX
   (add → toast → stay on page), using Shopify's cart AJAX API. */
(function () {
  "use strict";
  var RC = {};

  /* ---- toast (identical markup/behaviour to the original site) ---- */
  var toastTimer;
  RC.toast = function (html) {
    var el = document.querySelector(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      document.body.appendChild(el);
      // keep the toast up while the pointer is over it so links stay clickable
      el.addEventListener("mouseenter", function () { clearTimeout(toastTimer); });
      el.addEventListener("mouseleave", function () {
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { el.classList.remove("show"); }, 1200);
      });
    }
    el.innerHTML = html;
    requestAnimationFrame(function () { el.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("show"); }, 4200);
  };

  RC.updateCount = function (n) {
    document.querySelectorAll("#cart-count, .cart-count").forEach(function (el) {
      el.textContent = n;
    });
  };

  /* ---- add to basket ---- */
  RC.addToCart = function (variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || "Sorry, that couldn't be added.");
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        RC.updateCount(cart.item_count);
        RC.toast('Added to basket &nbsp;&middot;&nbsp; <a href="/cart">View basket &rarr;</a>');
        return cart;
      })
      .catch(function (err) {
        RC.toast(String(err.message || err));
        throw err;
      });
  };

  /* ---- change / remove a cart line (used on the cart page) ---- */
  RC.changeLine = function (key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  };

  /* ---- mobile hamburger navigation ---- */
  RC.initNav = function () {
    var header = document.querySelector(".site-header");
    var toggle = document.getElementById("nav-toggle");
    var nav = document.getElementById("site-nav");
    if (!header || !toggle || !nav) return;

    var backdrop = document.createElement("div");
    backdrop.className = "nav-backdrop";
    document.body.appendChild(backdrop);

    function setOpen(open) {
      header.classList.toggle("nav-open", open);
      document.body.classList.toggle("nav-lock", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    }

    toggle.addEventListener("click", function () {
      setOpen(!header.classList.contains("nav-open"));
    });
    backdrop.addEventListener("click", function () { setOpen(false); });
    nav.addEventListener("click", function (e) {
      if (e.target.closest("a")) setOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.key === "Esc") setOpen(false);
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 860 && header.classList.contains("nav-open")) setOpen(false);
    });
  };

  /* ---- collapsible categories sidebar (mobile) ---- */
  RC.initCatToggle = function () {
    var sidebar = document.querySelector(".shop-sidebar");
    var toggle = document.getElementById("cat-toggle");
    if (!sidebar || !toggle) return;
    var mq = window.matchMedia("(max-width: 900px)");

    function setOpen(open) {
      sidebar.classList.toggle("cats-collapsed", !open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function sync() { setOpen(!mq.matches); } // desktop open, mobile collapsed

    toggle.addEventListener("click", function () {
      if (!mq.matches) return; // no toggling on desktop
      setOpen(sidebar.classList.contains("cats-collapsed"));
    });
    if (mq.addEventListener) { mq.addEventListener("change", sync); }
    else if (mq.addListener) { mq.addListener(sync); }
    sync();
  };

  function initAll() { RC.initNav(); RC.initCatToggle(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.RC = RC;
})();
